import React, { useEffect, useState } from 'react';
import { Badge } from '@/components/ui/badge';
import { Clock } from 'lucide-react';
import { cn } from '@/lib/utils';

/**
 * Countdown live dell'hold camera (Fase A · D3).
 * Mostra il tempo residuo mm:ss durante il quale la camera resta "trattenuta".
 * Alla scadenza chiama ``onExpire`` (tipicamente un refresh del carrello).
 */
export function HoldCountdown({ expiresAt, onExpire, className }) {
  const calc = () => (expiresAt ? Math.max(0, Math.floor((new Date(expiresAt).getTime() - Date.now()) / 1000)) : 0);
  const [left, setLeft] = useState(calc);

  useEffect(() => {
    setLeft(calc());
    const t = setInterval(() => {
      setLeft((prev) => {
        const v = calc();
        if (v <= 0) { clearInterval(t); if (prev > 0) onExpire?.(); }
        return v;
      });
    }, 1000);
    return () => clearInterval(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expiresAt]);

  if (!expiresAt) return null;
  const mm = String(Math.floor(left / 60)).padStart(2, '0');
  const ss = String(left % 60).padStart(2, '0');
  const urgent = left > 0 && left <= 120;
  return (
    <Badge
      variant={urgent ? 'destructive' : 'secondary'}
      className={cn('gap-1 font-normal tabular-nums', className)}
      data-testid="hold-countdown"
      title="Camera trattenuta per te per pochi minuti"
    >
      <Clock className="h-3 w-3" />
      {left > 0 ? `Trattenuta ${mm}:${ss}` : 'Scaduta'}
    </Badge>
  );
}

export default HoldCountdown;
